/** 키보드 단축키 처리 훅 */

import { useEffect } from "react";
import { MatchNavigation } from "@/app/ixd-dsd-compare/types";

interface UseKeyboardShortcutsParams {
  matchNavigation: MatchNavigation | null;
  onNavigatePrev: () => void;
  onNavigateNext: () => void;
  onNavigateClose: () => void;
}

const isKeyboardInputTarget = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) return false;
  return (
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement ||
    target.isContentEditable
  );
};

export const useKeyboardShortcuts = ({
  matchNavigation,
  onNavigatePrev,
  onNavigateNext,
  onNavigateClose,
}: UseKeyboardShortcutsParams) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (isKeyboardInputTarget(e.target)) return;

      // Shift + 방향키 — 매칭 셀 이동. Shift 없는 방향키는 셀 자체 이동·셀렉션에
      // 사용되므로 충돌을 피한다.
      if (e.shiftKey && (e.key === "ArrowUp" || e.key === "ArrowLeft")) {
        if (matchNavigation) {
          e.preventDefault();
          onNavigatePrev();
        }
      } else if (
        e.shiftKey &&
        (e.key === "ArrowDown" || e.key === "ArrowRight")
      ) {
        if (matchNavigation) {
          e.preventDefault();
          onNavigateNext();
        }
      } else if (e.key === "Escape") {
        onNavigateClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [matchNavigation, onNavigatePrev, onNavigateNext, onNavigateClose]);
};
